import { Link } from 'react-router-dom';

import { ContactForm } from '../components/contact-form';

export default function Offerings() {
  return (
    <div>
      <section
        className="relative overflow-hidden py-16"
        style={{ background: "var(--gradient-hero)" }}
      >
        <div className="pointer-events-none absolute inset-0">
          <div className="aurora" />
          <div className="noise" />
        </div>

        <div className="container-ivalue relative">
          <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
            Offerings
          </div>
          <h1 className="mt-4 text-balance text-4xl font-extrabold tracking-[-0.03em] text-text-primary md:text-6xl">
            Control engineering services
            <br />
            from assessment to automation
          </h1>
          <p className="mt-5 max-w-3xl text-lg leading-relaxed text-text-secondary">
            Engagements designed for audit success, measurable risk reduction, and continuous assurance.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/contact#contact-form"
              className="focus-ring sheen inline-flex h-12 items-center justify-center rounded-xl bg-gradient-to-r from-[#3B82F6] to-[#1D4ED8] px-5 text-sm font-semibold text-white transition-transform hover:scale-[1.02] active:scale-[0.98]"
            >
              Request Assessment →
            </Link>
            <Link
              to="/contact#contact-form"
              className="focus-ring inline-flex h-12 items-center justify-center rounded-xl border border-border-subtle bg-white/5 px-5 text-sm font-semibold text-text-primary transition-colors hover:bg-white/10"
            >
              Talk to an expert
            </Link>
          </div>
        </div>
      </section>

      <section className="bg-background-primary py-20">
        <div className="container-ivalue">
          <div className="grid gap-4 lg:grid-cols-2">
            <div className="glass-card sheen p-6">
              <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
                1. Regulatory readiness assessment
              </div>
              <div className="mt-3 text-xl font-semibold text-text-primary">
                Gap analysis against selected frameworks
              </div>
              <div className="mt-2 text-sm text-text-secondary">
                Scope: control-by-control assessment across RBI / CERT-In / SEBI / IRDAI / ISO / PCI, etc.
              </div>
              <div className="mt-4 grid gap-2 sm:grid-cols-2">
                <div className="rounded-xl border border-border-subtle bg-white/5 px-3 py-2 text-sm text-text-secondary">
                  Duration: 2–4 weeks
                </div>
                <div className="rounded-xl border border-border-subtle bg-white/5 px-3 py-2 text-sm text-text-secondary">
                  Output: audit-ready gap report
                </div>
              </div>
              <div className="mt-4 space-y-2">
                {[
                  "Comprehensive gap report with risk ratings",
                  "Control-by-control compliance status",
                  "Prioritized remediation roadmap",
                  "Quick wins identification",
                  "Executive summary for Board/Management",
                ].map((d) => (
                  <div
                    key={d}
                    className="rounded-xl border border-border-subtle bg-white/5 px-3 py-2 text-sm text-text-secondary"
                  >
                    {d}
                  </div>
                ))}
              </div>
              <div className="mt-6">
                <Link
                  to="/assessment"
                  className="focus-ring inline-flex h-11 items-center justify-center rounded-xl border border-border-subtle bg-white/5 px-4 text-sm font-semibold text-text-primary hover:bg-white/10"
                >
                  Request Assessment →
                </Link>
              </div>
            </div>

            {[
              {
                n: "2. Control architecture & design",
                s: "End-to-end control framework design",
                d: "4–8 weeks",
                outs: [
                  "Control catalog and mapping",
                  "Policy templates",
                  "Procedure guides",
                  "RACI matrix",
                ],
              },
              {
                n: "3. Technology selection & implementation",
                s: "Tool evaluation, POC, deployment, integration",
                d: "8–16 weeks",
                outs: [
                  "Evaluation matrix",
                  "Architecture design",
                  "Deployed solution",
                  "Runbooks",
                ],
              },
              {
                n: "4. Compliance automation engineering",
                s: "Evidence automation, dashboards, API integration",
                d: "6–12 weeks",
                outs: [
                  "Automated evidence pipelines",
                  "Live compliance dashboards",
                  "Alert rules",
                  "Evidence integrity + retention",
                ],
              },
              {
                n: "5. Managed continuous compliance",
                s: "Ongoing monitoring, assessment, reporting",
                d: "Annual engagement",
                outs: [
                  "Monthly reports",
                  "Quarterly assessments",
                  "Audit support",
                  "Trend analysis",
                ],
              },
              {
                n: "6. Audit & regulator support",
                s: "Audit preparation, evidence assembly, regulator liaison",
                d: "Per audit cycle",
                outs: [
                  "Evidence packages",
                  "Audit readiness report",
                  "Remediation tracking",
                  "Mock audit",
                ],
              },
            ].map((x) => (
              <div key={x.n} className="glass-card sheen p-6">
                <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
                  {x.n}
                </div>
                <div className="mt-3 text-xl font-semibold text-text-primary">
                  {x.s}
                </div>
                <div className="mt-2 text-sm text-text-secondary">
                  Duration: {x.d}
                </div>
                <div className="mt-4 space-y-2">
                  {x.outs.map((d) => (
                    <div
                      key={d}
                      className="rounded-xl border border-border-subtle bg-white/5 px-3 py-2 text-sm text-text-secondary"
                    >
                      {d}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10 glass-card p-6">
            <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
              Engagement models
            </div>
            <div className="mt-4 grid gap-3 md:grid-cols-2 lg:grid-cols-4">
              {[
                {
                  t: "Project-based",
                  d: "Fixed scope, timeline, deliverables",
                },
                {
                  t: "Retainer",
                  d: "Monthly hours for ongoing support",
                },
                {
                  t: "Managed Service",
                  d: "Full compliance operations outsourcing",
                },
                {
                  t: "Hybrid",
                  d: "Combination based on needs",
                },
              ].map((m) => (
                <div
                  key={m.t}
                  className="rounded-2xl border border-border-subtle bg-white/5 p-5"
                >
                  <div className="text-lg font-semibold text-text-primary">
                    {m.t}
                  </div>
                  <div className="mt-2 text-sm text-text-secondary">{m.d}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-10 glass-card p-6" id="contact-form">
            <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
              Talk to an expert
            </div>
            <div className="mt-3 text-sm text-text-secondary">
              Tell us the frameworks in scope and we will share a control roadmap + implementation approach.
            </div>
            <div className="mt-6">
              <ContactForm title="Offerings enquiry" subtitle="Assessment, implementation, or managed continuous compliance." ctaLabel="Send" />
            </div>
            <div className="mt-4">
              <Link
                to="/contact#contact-form"
                className="focus-ring inline-flex h-11 items-center justify-center rounded-xl border border-border-subtle bg-white/5 px-4 text-sm font-semibold text-text-primary hover:bg-white/10"
              >
                Open full contact page →
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
